/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

import "./src/jquery";

$(function() {
  let $el = $('.tickets-table-' + $('#performance_id').val());
  $('body').on("change", function() {
    $el = $('.tickets-table-' + $('#performance_id').val());
    let sum = 0;
    let overall = 0;
    $el.find(".price").each((index, element) => {
        const val = $(element).attr("cs_data");
        const sel = $(element).next('select')[0];
        if (sel) {
          const cnt = sel.options[sel.selectedIndex].value;
          sum += parseFloat( val.replace(/,/,'.') ) * cnt;
          return overall += cnt;
        }
    });

    $el.find('.total').html( sum.toFixed(2).replace(/\./,',') + " " + $('#currency').val() );

    if (overall > 0) {
      $el.find('.submit-button').removeAttr("disabled");
      $el.find('.add-to-cart-button').removeAttr("disabled");
    } else {
      $el.find('.submit-button').attr("disabled", "disabled");
      $el.find('.add-to-cart-button').attr("disabled", "disabled");
    }
    return sum;
  });

  if ($el.find("select.count_select").length <= 0) {
    $el.find('.submit-button').attr("disabled", "disabled");
    $el.find('.add-to-cart-button').attr("disabled", "disabled");
  }

  $el.find("select.count_select").change();

  const show_event_link = () => $('.event-link').slideDown();

  const show_added_and_cart_link = () => $('.added-and-cart-link').slideDown();

  const open_popup = link => window.open(
    link,
    "_blank",
    "resizable=yes,scrollbars=yes,status=yes,menubar=yes"
  );

  const trigger_cart_event = event => {
    console.log($(".count_select"));
    let sum = 0;
    $('.count_select :selected').each(function() {
      return sum += Number($(this).val());
    });

    return parent.postMessage({
      event: "NtryCart",
      detail: {
        ticketsAdded: sum,
        secondsReserved: $("#timeout").val() * 60
      }
    }, "*");
  };

  // When submitting the order form, we open an iframe and include the promo
  // code in the request
  $('form#new_order').submit(function(event) {
    event.stopPropagation();
    event.preventDefault();
    trigger_cart_event(event);
    show_event_link();
    return open_popup($('#popup_items_url').val() + "&" + $('form#new_order').serialize());
  });

  // When submitting the promo code form, we open an iframe and include the promo
  // code in the request
  $('form#promo-form').submit(function(event) {
    event.stopPropagation();
    event.preventDefault();
    show_event_link();
    return open_popup($('#popup_promocode_items_url').val() + "&" + $('form#promo-form').serialize());
  });

  // When clicking the "open cart window" link, we simply open the popup without
  // adding any cart item
  $('a.open-cart-window').click(function(event) {
    event.stopPropagation();
    event.preventDefault();
    show_event_link();
    return open_popup($('#popup_items_url').val());
  });

  // when clicking the "add to cart" button, we trigger the request via a hidden
  // iframe and inform the user when the content is loaded
  $('button.add-to-cart-button').click(function(event) {
    event.stopPropagation();
    event.preventDefault();
    trigger_cart_event(event);

    const $button = $(this);

    const original_text = $button.text();
    $button.attr('disabled', 'disabled');
    $button.text(original_text + '...');

    const url = $('#popup_items_url').val() + "&"+ $('form#new_order').serialize();

    const $iframe = $('<iframe id="background-request" style="display:none;"></iframe>');
    $iframe.on('load', function() {
      show_added_and_cart_link();
      $button.attr('disabled', null);
      return $button.text(original_text);
    });
    $iframe.attr('src', url);
    return $('body').append($iframe);
  });

  // When clicking the "reserve seat" button, we link the user to the seat
  // selection via iframe
  return $('.seat_reservation_btn').click(function(event) {
    event.stopPropagation();
    event.preventDefault();
    show_event_link();
    return open_popup($(this).data('path'));
  });
});
